import classNames from 'classnames';
import React from 'react';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { Help } from './KlaviyoHelpLink';
import { KlaviyoSetupMode } from './KlaviyoIntegrations';
import styles from './KlaviyoIntegrations.module.css';

export const KlaviyoConnectionModeSelector = ({
  onSelectMode,
  helpLink,
}: {
  onSelectMode: (mode: KlaviyoSetupMode) => void;
  helpLink: string;
}) => (
  <div className={classNames(styles.box, styles.boxWithHelp)}>
    <div className={styles.boxContent}>
      <div className={styles.heading}>Sign in Directly with Klaviyo</div>
      <div className={styles.connectionButtonsWrapper}>
        <PrimaryButton
          css={{ container: 'integrations__header-add-button-secondary' }}
          color={ButtonColor.secondaryBlue}
          onClick={() => onSelectMode('oauth')}
        >
          Sign in Directly
        </PrimaryButton>
      </div>
      <div className={styles.heading}>Connect with API Key</div>
      <div className={styles.connectionButtonsWrapper}>
        <PrimaryButton
          css={{ container: 'integrations__header-add-button-secondary' }}
          color={ButtonColor.secondaryBlue}
          onClick={() => onSelectMode('api_key')}
        >
          Connect with API Key
        </PrimaryButton>
      </div>
      <Help link={helpLink} text="Read Tutorial" />
    </div>
  </div>
);
